<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <div class="header-button" />
    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="questions"
      resource="worker"
    >
      <el-table-column
        prop="nickname"
        label="姓名"
      />
      <el-table-column
        prop="mobile"
        label="手机号"
      />

      <el-table-column
        prop="area_name"
        label="区域"
      />
      <el-table-column
        prop="question"
        :show-overflow-tooltip="true"
        label="反馈内容"
      />

      <el-table-column
        label="是否已读"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_read"
            type="success"
          >已读</el-tag>
          <el-tag
            v-else
            type="danger"
          >未读</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="添加时间"
        width="180"
      />
      <el-table-column
        label="操作"
        width="120"
      >
        <template #default="{ row, $index }">
          <el-button @click="detailClick(row,$index)"> 详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ detailQuestion }}</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getQuestions, isReadChange } from "@/api/feedback";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_read",
          label: "是否已读",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 0,
              name: "未读"
            },
            {
              id: 1,
              name: "已读"
            }
          ]
        }
      ],
      questions: [],
      page: null,
      first_blood: true,
      areas: [],
      detailQuestion: "",
      dialogVisible: false
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getQuestions(newVal.query);
        this.questions = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    // console.log(11)
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.areas.push.apply(this.areas, areas);
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[2].options.push.apply(
          this.search[2].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    async detailClick(row, index) {
      this.dialogVisible = true;
      this.detailQuestion = row.question;
      // console.log(row.is_read)
      // console.log(this.questions[index])
      if (row.is_read === 0) {
        await isReadChange({ id: row.id }).then(res => {
          res.then(data => {
            this.questions[index].is_read = 1;
          });
        });
      }
    }
  }
};
</script>
<style lang="scss" scope>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.limitwidth {
  width: 40%;
  margin-right: 10px;
}
</style>
